export const reviews: Array<[string, string, string, string]> = [
  [
    'RP',
    'Ricardo P.',
    'Docente de Meteorología — México D.F., México',
    'Mis alumnos por fin entienden la diferencia entre nubes, precipitaciones y sistemas de presión, y cómo se forman las tormentas. Antes yo misma perdía tiempo buscando cómo explicar correctamente los procesos atmosféricos. Ahora entro al aula con todo listo.',
  ],
  [
    'MG',
    'Mariana G.',
    'Profesor de Ciencias Atmosféricas — Santiago, Chile',
    'Nunca más llegué a una clase sin saber cómo explicar los frentes, masas de aire o la circulación atmosférica. El material hace el trabajo pesado por mí.',
  ],
  [
    'TL',
    'Tomás L.',
    'Docente de Ciencias Naturales — Bogotá, Colombia',
    'Las planificaciones me ahorran horas. Los proyectos de meteorología están organizados paso a paso. No improviso nunca más frente a mis alumnos.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'MR',
    'Mariana R.',
    'Docente de Meteorología | Lima, Perú',
    'El material sobre masas de aire y frentes le cambió la cara a mis alumnos. Por fin entienden cómo se generan los cambios del tiempo. Es el recurso más claro que encontré para este tema. Lo uso desde la primera clase y los engancha de inmediato.',
  ],
  [
    'JC',
    'Jorge C.',
    'Profesor de Ciencias Naturales | Montevideo, Uruguay',
    'El banco de 150 actividades vale por sí solo el precio del pack. Nunca más improviso una clase. Salgo de cada trimestre con la satisfacción de tener todo resuelto y mis alumnos motivados.',
  ],
  [
    'FG',
    'Fernando G.',
    'Docente de Ciencias | Caracas, Venezuela',
    'Los 50 experimentos de laboratorio transformaron cómo mis alumnos aprenden. Ahora entienden por qué se forman las nubes, cómo funciona la presión y qué causa el viento. Lo aplican directamente a la realidad de su ciudad. Eso no lo encontré en ningún otro material.',
  ],
  [
    'LM',
    'Laura M.',
    'Docente universitaria | Buenos Aires, Argentina',
    'El kit de evaluación me devolvió el tiempo de clase. Antes perdía mucho tiempo armando exámenes y rúbricas. Ahora tengo todo listo, coherente y vinculado con los contenidos. Mis alumnos saben exactamente qué van a ser evaluados.',
  ],
  [
    'PP',
    'Pablo P.',
    'Profesor de Meteorología | Quito, Ecuador',
    'Las 100 secuencias didácticas fueron una revelación. Mis alumnos finalmente entienden para qué es todo esto. Observan fenómenos meteorológicos reales, analizan mapas del tiempo y comprenden cómo la meteorología afecta sus vidas. Eso cambió completamente su relación con la atmósfera.',
  ],
];
